import Blacklight from '../blacklight'
import $ from 'jquery'
import * as Leaflet from 'leaflet'
import 'leaflet/dist/leaflet.css'

const iconRetinaUrl = new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href;
const iconUrl = new URL('leaflet/dist/images/marker-icon.png', import.meta.url).href;
const shadowUrl = new URL('leaflet/dist/images/marker-shadow.png', import.meta.url).href;

function initialize(){
    $('[data-coordinates]:not(.leaflet-container)').each((i, el) => {
        const coordinates = $(el).data('coordinates').split(/, */).map(parseFloat);
        const instName = $(el).data('inst-name');
        const googleLink = $(el).data('google-link');
        const linkElem =  $('<a>',{
            text: instName,
            href: googleLink
        });
        const map = Leaflet.map(el, {
            scrollWheelZoom: false,
            center: coordinates,
            zoom: 11
        });
        Leaflet.tileLayer(
            'https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}.png',
            {
                id: 'osm.default',
                attribution: '© OpenStreetMap, © CartoDB'
            }
        ).addTo(map);
        delete Leaflet.Icon.Default.prototype._getIconUrl;
        Leaflet.Icon.Default.mergeOptions({
            iconRetinaUrl,
            iconUrl,
            shadowUrl,
        });
        Leaflet.marker(coordinates)
            .addTo(map)
            .bindPopup(linkElem.prop('outerHTML'))
            .openPopup();
    });
}

Blacklight.onLoad(initialize);
initialize();
